// This file is auto-generated by @hey-api/openapi-ts

import type { DeleteCommentsByIdUnlikeResponse, DeleteMatchesByIdResponse, DeletePositionedBannersByIdResponse, DeletePostsByIdUnlikeResponse, GetClubsByIdFeedResponse, GetClubsByIdResponse, GetDrawsByIdResponse, GetFitPlayerProfilesByIdResponse, GetMatchesByIdResponse, GetMatchesResponse, GetPositionedBannersByIdByIdResponse, GetPositionedBannersResponse, GetUsersByIdPostsResponse, GetUsersByIdPreviewResponse, GetUsersFeedMatchesResponse, GetUsersFeedNewsResponse, GetUsersFeedOffersResponse, GetUsersFeedPostsResponse, GetUsersFeedResponse, GetUsersFollowersListByIdResponse, GetUsersUserMatchesResponse, PostCommentsByIdLikeResponse, PostFitPlayerProfilesAdvancedSearchResponse, PostPositionedBannersResponse, PostPostsByIdLikeResponse, PostPostsResponse, PostSessionsBackofficeResponse, PostSessionsFacebookResponse, PostSessionsResponse, PostUsersMarketResponse, PostUsersSignUpAdditionalInfoResponse, PostUsersSignUpResponse, PutDrawsByIdChangeBestLoserRankingResponse, PutDrawsByIdChangeWinnerResponse, PutDrawsByIdDeleteMatchesResponse, PutEditProfileGeneralInfoResponse, PutMatchesByIdResponse, PutMatchesByIdResultResponse, PutPositionedBannersByIdResponse } from './types.gen';

export const postSessionsFacebookResponseTransformer = async (data: any): Promise<PostSessionsFacebookResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
        if (data.user.token_expiration) {
            data.user.token_expiration = new Date(data.user.token_expiration);
        }
        if (data.user.premium_expiration) {
            data.user.premium_expiration = new Date(data.user.premium_expiration);
        }
    }
    return data;
};

export const postSessionsBackofficeResponseTransformer = async (data: any): Promise<PostSessionsBackofficeResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
        if (data.user.token_expiration) {
            data.user.token_expiration = new Date(data.user.token_expiration);
        }
        if (data.user.premium_expiration) {
            data.user.premium_expiration = new Date(data.user.premium_expiration);
        }
    }
    return data;
};

const fitPlayerProfileSchemaResponseTransformer = (data: any) => {
    if (data.birth_date) {
        data.birth_date = new Date(data.birth_date);
    }
    if (data.certificate_expiration) {
        data.certificate_expiration = new Date(data.certificate_expiration);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

const competitionSchemaResponseTransformer = (data: any) => {
    data.from = new Date(data.from);
    data.to = new Date(data.to);
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

const postSchemaResponseTransformer = (data: any) => {
    data.comments = data.comments.map((item: any) => {
        return commentSchemaResponseTransformer(item);
    });
    return data;
};

const commentSchemaResponseTransformer = (data: any) => {
    if (data.children) {
        data.children = data.children.map((item: any) => {
            return commentSchemaResponseTransformer(item);
        });
    }
    return data;
};

const drawSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    if (data.match_date) {
        data.match_date = new Date(data.match_date);
    }
    return data;
};

export const getClubsByIdResponseTransformer = async (data: any): Promise<GetClubsByIdResponse> => {
    if (data.members) {
        data.members = data.members.map((item: any) => {
            return fitPlayerProfileSchemaResponseTransformer(item);
        });
    }
    if (data.teachers) {
        data.teachers = data.teachers.map((item: any) => {
            return fitPlayerProfileSchemaResponseTransformer(item);
        });
    }
    if (data.competitions) {
        data.competitions = data.competitions.map((item: any) => {
            return competitionSchemaResponseTransformer(item);
        });
    }
    if (data.feed) {
        data.feed = data.feed.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    if (data.draws) {
        data.draws = data.draws.map((item: any) => {
            return drawSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getClubsByIdFeedResponseTransformer = async (data: any): Promise<GetClubsByIdFeedResponse> => {
    if (data.feed) {
        data.feed = data.feed.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const postCommentsByIdLikeResponseTransformer = async (data: any): Promise<PostCommentsByIdLikeResponse> => {
    data.comment = commentSchemaResponseTransformer(data.comment);
    return data;
};

export const deleteCommentsByIdUnlikeResponseTransformer = async (data: any): Promise<DeleteCommentsByIdUnlikeResponse> => {
    if (data.comment) {
        data.comment = commentSchemaResponseTransformer(data.comment);
    }
    return data;
};

const drawResponseSchemaResponseTransformer = (data: any) => {
    if (data.winner) {
        if (data.winner.premium_expiration) {
            data.winner.premium_expiration = new Date(data.winner.premium_expiration);
        }
    }
    data.matches = data.matches.map((item: any) => {
        if (item.draw) {
            item.draw = drawSummarySchemaResponseTransformer(item.draw);
        }
        if (item.first_player) {
            if (item.first_player.premium_expiration) {
                item.first_player.premium_expiration = new Date(item.first_player.premium_expiration);
            }
        }
        if (item.second_player) {
            if (item.second_player.premium_expiration) {
                item.second_player.premium_expiration = new Date(item.second_player.premium_expiration);
            }
        }
        return item;
    });
    return data;
};

const drawSummarySchemaResponseTransformer = (data: any) => {
    if (data.match_date) {
        data.match_date = new Date(data.match_date);
    }
    return data;
};

export const getDrawsByIdResponseTransformer = async (data: any): Promise<GetDrawsByIdResponse> => {
    data = drawResponseSchemaResponseTransformer(data);
    return data;
};

export const putDrawsByIdDeleteMatchesResponseTransformer = async (data: any): Promise<PutDrawsByIdDeleteMatchesResponse> => {
    if (data.draw) {
        data.draw = drawResponseSchemaResponseTransformer(data.draw);
    }
    return data;
};

export const putDrawsByIdChangeWinnerResponseTransformer = async (data: any): Promise<PutDrawsByIdChangeWinnerResponse> => {
    if (data.draw) {
        data.draw = drawResponseSchemaResponseTransformer(data.draw);
    }
    return data;
};

export const putDrawsByIdChangeBestLoserRankingResponseTransformer = async (data: any): Promise<PutDrawsByIdChangeBestLoserRankingResponse> => {
    if (data.draw) {
        data.draw = drawResponseSchemaResponseTransformer(data.draw);
    }
    return data;
};

export const putEditProfileGeneralInfoResponseTransformer = async (data: any): Promise<PutEditProfileGeneralInfoResponse> => {
    if (data.birth_date) {
        data.birth_date = new Date(data.birth_date);
    }
    return data;
};

const fitPlayerProfileResponseSchemaResponseTransformer = (data: any) => {
    if (data.premium_expiration) {
        data.premium_expiration = new Date(data.premium_expiration);
    }
    return data;
};

export const getFitPlayerProfilesByIdResponseTransformer = async (data: any): Promise<GetFitPlayerProfilesByIdResponse> => {
    data = fitPlayerProfileResponseSchemaResponseTransformer(data);
    return data;
};

const fitPlayerProfileAdvancedSearchSchemaResponseTransformer = (data: any) => {
    if (data.premium_expiration) {
        data.premium_expiration = new Date(data.premium_expiration);
    }
    return data;
};

export const postFitPlayerProfilesAdvancedSearchResponseTransformer = async (data: any): Promise<PostFitPlayerProfilesAdvancedSearchResponse> => {
    if (data.results) {
        data.results = data.results.map((item: any) => {
            return fitPlayerProfileAdvancedSearchSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const postPostsByIdLikeResponseTransformer = async (data: any): Promise<PostPostsByIdLikeResponse> => {
    if (data.post) {
        data.post = postSchemaResponseTransformer(data.post);
    }
    return data;
};

export const deletePostsByIdUnlikeResponseTransformer = async (data: any): Promise<DeletePostsByIdUnlikeResponse> => {
    if (data.post) {
        data.post = postSchemaResponseTransformer(data.post);
    }
    return data;
};

const matchSearchSchemaResponseTransformer = (data: any) => {
    if (data.first_winner) {
        if (data.first_winner.premium_expiration) {
            data.first_winner.premium_expiration = new Date(data.first_winner.premium_expiration);
        }
    }
    if (data.second_winner) {
        if (data.second_winner.premium_expiration) {
            data.second_winner.premium_expiration = new Date(data.second_winner.premium_expiration);
        }
    }
    if (data.first_loser) {
        if (data.first_loser.premium_expiration) {
            data.first_loser.premium_expiration = new Date(data.first_loser.premium_expiration);
        }
    }
    if (data.second_loser) {
        if (data.second_loser.premium_expiration) {
            data.second_loser.premium_expiration = new Date(data.second_loser.premium_expiration);
        }
    }
    return data;
};

export const getMatchesResponseTransformer = async (data: any): Promise<GetMatchesResponse> => {
    data.matches = data.matches.map((item: any) => {
        return matchSearchSchemaResponseTransformer(item);
    });
    return data;
};

const matchUpdateResponseSchemaResponseTransformer = (data: any) => {
    data.match = matchResponseSchemaResponseTransformer(data.match);
    return data;
};

const matchResponseSchemaResponseTransformer = (data: any) => {
    if (data.first_winner) {
        if (data.first_winner.premium_expiration) {
            data.first_winner.premium_expiration = new Date(data.first_winner.premium_expiration);
        }
    }
    if (data.second_winner) {
        if (data.second_winner.premium_expiration) {
            data.second_winner.premium_expiration = new Date(data.second_winner.premium_expiration);
        }
    }
    if (data.first_loser) {
        if (data.first_loser.premium_expiration) {
            data.first_loser.premium_expiration = new Date(data.first_loser.premium_expiration);
        }
    }
    if (data.second_loser) {
        if (data.second_loser.premium_expiration) {
            data.second_loser.premium_expiration = new Date(data.second_loser.premium_expiration);
        }
    }
    return data;
};

export const deleteMatchesByIdResponseTransformer = async (data: any): Promise<DeleteMatchesByIdResponse> => {
    data = matchUpdateResponseSchemaResponseTransformer(data);
    return data;
};

export const getMatchesByIdResponseTransformer = async (data: any): Promise<GetMatchesByIdResponse> => {
    data = matchResponseSchemaResponseTransformer(data);
    return data;
};

export const putMatchesByIdResponseTransformer = async (data: any): Promise<PutMatchesByIdResponse> => {
    data = matchUpdateResponseSchemaResponseTransformer(data);
    return data;
};

export const putMatchesByIdResultResponseTransformer = async (data: any): Promise<PutMatchesByIdResultResponse> => {
    data = matchUpdateResponseSchemaResponseTransformer(data);
    return data;
};

export const postPostsResponseTransformer = async (data: any): Promise<PostPostsResponse> => {
    if (data.post) {
        data.post = postSchemaResponseTransformer(data.post);
    }
    return data;
};

export const postUsersSignUpResponseTransformer = async (data: any): Promise<PostUsersSignUpResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
    }
    return data;
};

export const postUsersSignUpAdditionalInfoResponseTransformer = async (data: any): Promise<PostUsersSignUpAdditionalInfoResponse> => {
    if (data.user.birth_date) {
        data.user.birth_date = new Date(data.user.birth_date);
    }
    return data;
};

export const postSessionsResponseTransformer = async (data: any): Promise<PostSessionsResponse> => {
    if (data.user) {
        if (data.user.birth_date) {
            data.user.birth_date = new Date(data.user.birth_date);
        }
        if (data.user.token_expiration) {
            data.user.token_expiration = new Date(data.user.token_expiration);
        }
        if (data.user.premium_expiration) {
            data.user.premium_expiration = new Date(data.user.premium_expiration);
        }
    }
    return data;
};

export const getUsersByIdPostsResponseTransformer = async (data: any): Promise<GetUsersByIdPostsResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

const userSchemaResponseTransformer = (data: any) => {
    if (data.birth_date) {
        data.birth_date = new Date(data.birth_date);
    }
    if (data.banned_at) {
        data.banned_at = new Date(data.banned_at);
    }
    if (data.confirmed_at) {
        data.confirmed_at = new Date(data.confirmed_at);
    }
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data.updated_at) {
        data.updated_at = new Date(data.updated_at);
    }
    if (data.notifications_last_seen) {
        data.notifications_last_seen = new Date(data.notifications_last_seen);
    }
    if (data.first_sign_in_at) {
        data.first_sign_in_at = new Date(data.first_sign_in_at);
    }
    return data;
};

export const getUsersByIdPreviewResponseTransformer = async (data: any): Promise<GetUsersByIdPreviewResponse> => {
    if (data.user) {
        data.user = userSchemaResponseTransformer(data.user);
    }
    return data;
};

export const getUsersFollowersListByIdResponseTransformer = async (data: any): Promise<GetUsersFollowersListByIdResponse> => {
    if (data.followers) {
        data.followers = data.followers.map((item: any) => {
            return userSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getUsersFeedResponseTransformer = async (data: any): Promise<GetUsersFeedResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getUsersFeedPostsResponseTransformer = async (data: any): Promise<GetUsersFeedPostsResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

const matchSchemaResponseTransformer = (data: any) => {
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const getUsersFeedMatchesResponseTransformer = async (data: any): Promise<GetUsersFeedMatchesResponse> => {
    if (data.matches) {
        data.matches = data.matches.map((item: any) => {
            return matchSchemaResponseTransformer(item);
        });
    }
    return data;
};

const offerSchemaResponseTransformer = (data: any) => {
    if (data.sale_end) {
        data.sale_end = new Date(data.sale_end);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const getUsersFeedOffersResponseTransformer = async (data: any): Promise<GetUsersFeedOffersResponse> => {
    if (data.offers) {
        data.offers = data.offers.map((item: any) => {
            return offerSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const getUsersFeedNewsResponseTransformer = async (data: any): Promise<GetUsersFeedNewsResponse> => {
    if (data.posts) {
        data.posts = data.posts.map((item: any) => {
            return postSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const postUsersMarketResponseTransformer = async (data: any): Promise<PostUsersMarketResponse> => {
    if (data.offers) {
        data.offers = data.offers.map((item: any) => {
            return offerSchemaResponseTransformer(item);
        });
    }
    return data;
};

const userMatchSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    if (data.confirmed_at) {
        data.confirmed_at = new Date(data.confirmed_at);
    }
    if (data.rejected_at) {
        data.rejected_at = new Date(data.rejected_at);
    }
    data.created_at = new Date(data.created_at);
    data.updated_at = new Date(data.updated_at);
    return data;
};

export const getUsersUserMatchesResponseTransformer = async (data: any): Promise<GetUsersUserMatchesResponse> => {
    if (data.user_matches) {
        data.user_matches = data.user_matches.map((item: any) => {
            return userMatchSchemaResponseTransformer(item);
        });
    }
    return data;
};

const positionedBannerResponseSchemaResponseTransformer = (data: any) => {
    if (data.custom_banners) {
        data.custom_banners = data.custom_banners.map((item: any) => {
            return customBannerSchemaResponseTransformer(item);
        });
    }
    return data;
};

const customBannerSchemaResponseTransformer = (data: any) => {
    if (data.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data.updated_at) {
        data.updated_at = new Date(data.updated_at);
    }
    return data;
};

export const getPositionedBannersResponseTransformer = async (data: any): Promise<GetPositionedBannersResponse> => {
    if (data.data) {
        data.data = data.data.map((item: any) => {
            return positionedBannerResponseSchemaResponseTransformer(item);
        });
    }
    return data;
};

export const postPositionedBannersResponseTransformer = async (data: any): Promise<PostPositionedBannersResponse> => {
    data.positioned_banner = positionedBannerResponseSchemaResponseTransformer(data.positioned_banner);
    return data;
};

export const getPositionedBannersByIdByIdResponseTransformer = async (data: any): Promise<GetPositionedBannersByIdByIdResponse> => {
    data = positionedBannerResponseSchemaResponseTransformer(data);
    return data;
};

export const deletePositionedBannersByIdResponseTransformer = async (data: any): Promise<DeletePositionedBannersByIdResponse> => {
    data.positioned_banner = positionedBannerResponseSchemaResponseTransformer(data.positioned_banner);
    return data;
};

export const putPositionedBannersByIdResponseTransformer = async (data: any): Promise<PutPositionedBannersByIdResponse> => {
    data.positioned_banner = positionedBannerResponseSchemaResponseTransformer(data.positioned_banner);
    return data;
};
